import React, { useState } from "react";
import styled from "styled-components";
import { FiSearch } from "react-icons/fi";

const mockData = [
  {
    name: "Sudhanshu Gaikwad",
    mobile: "8788365413",
    email: "sudhanshugaikwad123@gmail.com",
    date: "2025-05-15",
    time: "10:00 AM",
    dob: "18/08/2000", // Added DOB field for testing
  },
  {
    name: "Jane Smith",
    mobile: "9876543210",
    email: "jane@example.com",
    date: "2025-05-16",
    time: "11:30 AM",
    dob: "16/05/1990", // Added DOB field for testing
  },
];

const Appointment_Receipt = () => {
  const [nameSearch, setNameSearch] = useState("");
  const [dobSearch, setDobSearch] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);

  const handleSearch = () => {
    if (nameSearch && dobSearch) {
      setSearchClicked(true); // Trigger the data display when both inputs are filled
    }
  };

  const filteredData = mockData.filter(
    (item) =>
      item.name.toLowerCase().includes(nameSearch.toLowerCase()) &&
      item.dob === dobSearch
  );

  return (
    <Wrapper>
      <Container>
        <SearchContainer>
          <SearchWrapper>
            <SearchInput
              type="text"
              placeholder="Enter Name"
              value={nameSearch}
              onChange={(e) => setNameSearch(e.target.value)}
            />
          </SearchWrapper>
          <SearchWrapper>
            <SearchInput
              type="text"
              placeholder="DD/MM/YYYY"
              value={dobSearch}
              onChange={(e) => setDobSearch(e.target.value)}
            />
          </SearchWrapper>

          <SearchButton onClick={handleSearch}>
            <FiSearch />
            Search
          </SearchButton>
        </SearchContainer>

        {searchClicked && (
          <TableWrapper>
            <Table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th>Appointment Date</th>
                  <th>Appointment Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.mobile}</td>
                      <td>{item.email}</td>
                      <td>{item.date}</td>
                      <td>{item.time}</td>
                      <td>
                        <DownloadButton>Download Receipt</DownloadButton>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </TableWrapper>
        )}
      </Container>
    </Wrapper>
  );
};

export default Appointment_Receipt;

// Styled Components

const Wrapper = styled.div`
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: top;
  padding: 40px;
  background-color: #171719;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: "Segoe UI", sans-serif;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  border: 1px solid #353535;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  max-width: 400px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-size: 1rem;

  border-radius: 8px;
  outline: none;
  border: 1px solid #353535;
  background-color: transparent;
  color: #e6e6e6;

  &:focus {
    border-color: #3f51ff;
    outline: none;
  }
`;

const SearchButton = styled.button`
  background: #194bfd;
  background: linear-gradient(
    90deg,
    rgba(25, 75, 253, 1) 0%,
    rgba(173, 19, 251, 1) 100%
  );
  color: #ffffff;

  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #5a189a;

    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  th,
  td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #eee;
    min-width: 100px;
  }

  th {
    background-color: #f1f3f5;
    color: #343a40;
    font-weight: 600;
  }

  tr:hover {
    background-color: #f8f9fa;
  }

  @media (max-width: 768px) {
    th,
    td {
      font-size: 0.9rem;
      padding: 10px;
    }
  }
`;

const DownloadButton = styled.button`
  background: #194bfd;
  background: linear-gradient(
    90deg,
    rgba(25, 75, 253, 1) 0%,
    rgba(173, 19, 251, 1) 100%
  );
  color: #ffffff;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  &:hover {
    background-color: #5a189a;

    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;
